import type { SVGProps } from 'react';
const SvgViewSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_sidebar_svg__a)">
      <path
        fill="currentColor"
        d="M16 20H2V4h14v16Zm2-12h4V4h-4v4Zm0 12h4v-4h-4v4Zm0-6h4v-4h-4v4Z"
      />
    </g>
    <defs>
      <clipPath id="view_sidebar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewSidebar;
